import { Entity } from 'engine/Entity';
import { Facet } from 'engine/facets/Facet';
import clamp from 'lodash/clamp';

interface DoorBehaviorProps {
  range: number,
  speed: number,
  entity: Entity,
}

export class DoorBehavior extends Facet<DoorBehaviorProps> {

  xInit = 0;

  start() {
    this.xInit = this.props.entity.transform.position[0];
  }

  open(delta: number): boolean {
    const max = this.xInit + this.props.range;
    const { position } = this.props.entity.transform;
    position[0] = clamp(position[0] + this.props.speed * delta, max);
    return position[0] === max;
  }

  close(delta: number): boolean {
    const { position } = this.props.entity.transform;
    position[0] = clamp(position[0] - this.props.speed * delta, this.xInit, this.xInit + this.props.range);
    return position[0] === this.xInit;
  }
}
